module.exports = __webpack_public_path__ + "static/media/onboardingstep2.f0898bbe.svg";